import {
  Component,
  input
} from '@angular/core';

export type TitlePosition = 'start' | 'center';

@Component({
  selector: 'td-wb-page-header',
  templateUrl: 'page-header.component.html',
  styleUrls: ['page-header.component.scss'],
  host: {
    '[class.td-wb-page-header--center]': 'isCentered()',
    '[class.td-wb-page-header--force-center]': 'isMobileCentered()',
    '[class.td-wb-page-header--toolbar-offset--one]': 'isToolbarOffsetOne()',
    '[class.td-wb-page-header--toolbar-offset--two]': 'isToolbarOffsetTwo()',
    '[class.td-wb-page-header--toolbar-offset--three]': 'isToolbarOffsetThree()',
    '[class.td-wb-page-header--toolbar-offset--four]': 'isToolbarOffsetFour()'
  }
})
export class PageHeaderComponent {
  readonly position = input<TitlePosition>('start');
  readonly forceCenter = input<boolean>(false);
  readonly toolbarItemOffset = input<number>(0);

  protected isCentered(): boolean {
    return this.position() === 'center';
  }

  protected isMobileCentered(): boolean {
    return this.forceCenter() === true;
  }

  protected isToolbarOffsetOne(): boolean {
    return this.toolbarItemOffset() === 1;
  }

  protected isToolbarOffsetTwo(): boolean {
    return this.toolbarItemOffset() === 2;
  }

  protected isToolbarOffsetThree(): boolean {
    return this.toolbarItemOffset() === 3;
  }

  protected isToolbarOffsetFour(): boolean {
    return this.toolbarItemOffset() === 4;
  }
}

